import { useEffect, useState } from "react"
import { fetchGrantAdminRole, fetchRevokeAdminRole, fetchUser, fetchUsers } from "../UsersApi";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentLang, selectTranslations } from "../../../services/i18n/i18nSlice";

import suspend_img from '../../../assets/images/archive.svg'
import trash_img from '../../../assets/images/trash.svg'
import close_img from '../../../assets/images/close.svg'
import check_img from '../images/check.svg'
import reject_img from '../images/x.svg'


import { selectUserData, selectUserFields } from "../../../features/User/userSlice";
import {  Form } from "react-bootstrap";
import { ADMIN_PERMISSIONS, DEFAULT_FIELDS, USER_STATUS } from "../../../config/constants";
import Select from "react-select";
import { setLoading } from "../../../services/global/globalSlice";
import { toast } from "react-toastify";
import AddUserInput from "./AddUserInput";

export default function AdminPermissionModal (props) {

    const dispatch = useDispatch()
    const t = useSelector(selectTranslations)
    const adminData = useSelector(selectUserData)
    const [show, setShow] = useState(false)
    const [validatedForm, setValidatedForm] = useState(false)
    const [userData, setUserData] = useState(null)
    const userFields = useSelector(selectUserFields)

    const renderPermissionLevels = (admin_permission) => {
        const defaultPermission = [
            {value: 0, label: t.admins.permissions.no_access},
            {value: 1, label: t.admins.permissions.read},
            {value: 2, label: t.admins.permissions.write},
        ]
        return defaultPermission.filter(p => p.value <= admin_permission.level)
    }

    const loadUserData = async () => {
        dispatch(setLoading(true))
        const response = await fetchUser(props.userId)
        if(response.success){
            setUserData(response.data)
            setShow(true)
            dispatch(setLoading(false))
        } else {
            dispatch(setLoading(false))
        }
    }

    const handleEditAdminPermission = (p,e) => {
        let _userData = structuredClone(userData)
        _userData['permissions'] = {
            ..._userData.permissions || [],
            [p] : {
                ...(_userData?.permissions && _userData?.permissions[p]),
                level: e.target.value
            }
        }
        setUserData(_userData)
    }

    const handleEditAdminPermissionResources = (p,e) => {
        let _userData = structuredClone(userData)
        _userData['permissions'] = {
            ..._userData.permissions || [],
            [p] : {
                ..._userData.permissions[p],
                all_resources: e.target.checked
            }
        }
        setUserData(_userData)
    }

    const handleUpdateAdminPermission = async (event) => {
        dispatch(setLoading(true))
        const _userData = structuredClone(userData)
        const _updateData = {
            user_id : _userData.user_id,
            permissions: _userData.permissions
        }
        const response = await fetchGrantAdminRole(_updateData)
        if(response.success){
            toast.success(t.admins.admin_edited)
            dispatch(setLoading(false))
        } else {
            toast.error(t.admins.admin_edit_error)
            dispatch(setLoading(false))
        }
    };

    const handleSelectUser = (user) => {
        user['permissions'] = ADMIN_PERMISSIONS.reduce((o, key) => ({ ...o, [key]: {level:0, all_resources:false}}), {})
        setUserData(user)
    }

    const handleRevokeAdmin = async () => {
        const response = await fetchRevokeAdminRole(userData.user_id)
        if(response.success){
            toast.success(t.admins.admin_edited)
            dispatch(setLoading(false))
            setShow(false)
            setUserData(null)
            props.onCloseModal()
        } else {
            toast.error(t.admins.admin_edit_error)
            dispatch(setLoading(false))
        }
    }

    const onClose = () => {
        setShow(false)
        setUserData(null)
        props.onCloseModal()
    }

    useEffect(()=>{
        if(props.userId)
            loadUserData()
        if(props.isNew)
            setShow(true)
    },[props])

    return (
        <>
        <Modal
            show={show}
            onHide={onClose}
            keyboard={false}
            centered
            size={'lg'}
        >
            <Modal.Body>
                {
                    props.isNew && !userData? 
                    <>
                        <div className="d-flex justify-content-between">
                            <h2>{t.admins.new_admin}</h2>
                            <img src={close_img} onClick={onClose} />
                        </div>
                        <p className="mt-1">{t.admins.new_admin_text}</p>
                        <div className="mx-auto">
                            <AddUserInput onAddUser={handleSelectUser} label={t.admins.new_admin} /> 
                        </div>
                        
                    </> :
                    <>
                    <div className="d-flex justify-content-between">
                        <h2 className="">{userData?.firstname} {userData?.lastname}</h2>
                        <div className='d-flex justify-content-end mb-2'>
                            <div className='d-flex align-items-center pe-3'>
                                <div className='d-flex align-items-center ps-3 pointer'style={{color:"#181818",fontWeight:"500"}} onClick={handleRevokeAdmin} >
                                    <img src={trash_img} />
                                    <span className='ms-1 '>{t.admins.remove_admin}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        userData ?
                            <div className="permissions">
                                    <h5>Permessi</h5>
                                    {ADMIN_PERMISSIONS.map((p,i)=>{
                                        if(adminData?.permissions[p] && adminData?.permissions[p].level > 0)
                                            return(
                                                <div key={i} className="mb-2">
                                                    <label className="text-info">{t.admins.permissions[p]}</label>
                                                    <select className="form-control" onChange={(e)=>handleEditAdminPermission(p,e)} value={userData?.permissions ? userData?.permissions[p]?.level : 0}>
                                                        {
                                                            renderPermissionLevels(adminData?.permissions[p])?.map(p=>{
                                                                return(
                                                                    <option value={p.value} disabled={p.disabled}>{p.label}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                    {adminData?.permissions[p].all_resources ?
                                                        <Form.Check 
                                                            type={'checkbox'}
                                                            id={i}
                                                            label={t.admins.permissions.restricted_access}
                                                            checked={userData?.permissions ? userData?.permissions[p]?.all_resources : false}
                                                            className="mt-2"
                                                            onChange={(e)=>handleEditAdminPermissionResources(p,e)}
                                                        />
                                                    : null}
                                                    <hr />
                                                </div>
                                            )
                                        else    
                                            return null
                                    })}
                                </div> 
                            : ""
                    }
                        <div className="mt-4 d-flex w-100 justify-content-between">
                            <button className="secondary" onClick={onClose}>
                                {t.buttons.exit_without_save}
                            </button>
                            <button type="button" onClick={handleUpdateAdminPermission} >
                                {t.buttons.save_and_exit}
                            </button>
                        </div>
                    </>
                }
                
                
            </Modal.Body>
        </Modal>
        </>
    )
}